export function getCartItems() {
  return new Promise(resolve => {
    jUpsell
      .getJSON('/cart.js', function(cart) {
        resolve(cart.items);
      })
      .fail(() => {
        resolve([]);
      });
  });
}
